import { useTranslation } from "react-i18next";
import { Box, Typography, Divider } from "@mui/material";

import { Service } from "../../../../types/service.type";
import { Media } from "../../../../../../types/types";
import { VideoItem, VideoItemLoader } from "./VideoItem";

export const ProgramVideos = ({ service, isServiceLoading }: { service?: Service; isServiceLoading?: boolean }) => {
  const { t } = useTranslation("goService", { keyPrefix: "servicePage" });

  if (isServiceLoading) return <ProgramVideosLoader />;

  const { programContents } = service!;
  const videos = programContents?.map((content) => ({
    media: content.media,
    title: content.videoTitle,
    isFree: content.isFree,
    duration: content.duration,
  }));

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.title}>{t("programVideos")}</Typography>
      <Divider />
      <VideosList videos={videos} canRequest={service?.canRequest} />
    </Box>
  );
};

export const ProgramVideosLoader = () => {
  const { t } = useTranslation("goService", { keyPrefix: "servicePage" });

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.title}>{t("programVideos")}</Typography>
      <Divider />
      <Box sx={styles.videosList}>
        {[...Array(3)].map((_, index) => (
          <VideoItemLoader key={index} />
        ))}
      </Box>
    </Box>
  );
};

const VideosList = ({
  videos,
  canRequest,
}: {
  videos?: { media: Media; title: string; isFree: boolean; duration: number }[];
  canRequest?: boolean;
}) => {
  return (
    <Box sx={styles.videosList}>
      {videos?.map((video, index) => (
        <VideoItem key={video.media.id ? `${video.media.id}-${index}` : index} video={video} canRequest={canRequest} />
      ))}
    </Box>
  );
};

export default ProgramVideos;

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  },

  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },

  videosList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};
